export enum LPInviter {
  ANYONE = 3,
  FRIENDS_ONLY = 2,
  NO_ONE = 1,
}
